import { createContext, useContext } from "react";

export const LangContext = createContext({ lang: "it", setLang: () => {} });
export const useLang = () => useContext(LangContext);

export const dict = {
  it: {
    nav: { services: "Servizi", portfolio: "Lavori", blog: "Blog", gift: "Regalo", work: "Metodo", pricing: "Prezzi", about: "Chi sono", contact: "Contatti", cta: "Parliamo" },
    hero: {
      over: "Social Media Manager & Web Designer",
      lines: ["Rendo il tuo", "brand impossibile", "da ignorare."],
      italic: 1,
      sub: "Gestisco i tuoi social e costruisco il tuo sito web. Contenuti che fermano lo scroll, siti che trasformano visite in clienti.",
      cta1: "Inizia un progetto",
      cta2: "Vedi i prezzi",
      badge: "Disponibile per nuovi progetti",
      scroll: "Scorri",
      ring: "SOCIAL · SITI WEB · STRATEGIA · CONTENUTI · ",
    },
    marquee: ["Gestione Social Media", "Creazione Siti Web", "Strategia Digitale", "Brand Identity", "Contenuti Virali"],
    about: {
      over: "Chi sono",
      title: ["Non pubblico contenuti.", "Costruisco attenzione."],
      p1: "Sono Lene Mauro. Aiuto professionisti e piccole imprese a farsi notare online, con una presenza social curata e un sito web che lavora per loro, giorno e notte.",
      p2: "Un unico punto di riferimento per strategia, contenuti e web: meno agenzie da coordinare, più risultati da misurare.",
      sign: "— Lene",
    },
    services: {
      over: "Servizi",
      title: "Due mestieri, una sola visione.",
      items: [
        { n: "01", t: "Gestione Social Media", d: "Piano editoriale, grafiche, reel, storie e copy. Ogni mese, con costanza e una voce riconoscibile.", tags: ["Instagram", "Facebook", "TikTok", "LinkedIn"] },
        { n: "02", t: "Creazione Siti Web", d: "Siti su misura, veloci e mobile-first. Pensati per raccontare il tuo brand e convertire i visitatori.", tags: ["Design", "Sviluppo", "SEO base", "Form contatti"] },
      ],
    },
    works: {
      over: "Lavori realizzati",
      title: "Prima e dopo, senza filtri.",
      sub: "Profili social e siti web trasformati. Clicca su Prima / Dopo per vedere la differenza.",
      before: "Prima",
      after: "Dopo",
      project: "Progetto",
      live: "Online",
      visit: "Visita il sito",
      realDesc: { galliera: "Sito web per un centro odontoiatrico a San Venanzio di Galliera (Bologna): design elegante, prenotazione visite in evidenza e trattamenti presentati con chiarezza." },
      types: { social: "Social media", web: "Sito web", both: "Social + Sito web" },
    },
    bento: {
      over: "Cosa ottieni",
      title: "Dettagli che fanno la differenza.",
      a: { t: "Visual storytelling", d: "Un'estetica coerente che rende il tuo profilo riconoscibile al primo sguardo." },
      b: { t: "Pensato per convertire", d: "Ogni pagina guida verso un'azione chiara.", cta: "Prenota ora" },
      c: { t: "Mobile first", d: "Perfetto sullo schermo dove i tuoi clienti passano il tempo." },
      d: { t: "Crescita continua", d: "Report mensili per capire cosa funziona e migliorare ogni mese." },
    },
    process: {
      over: "Metodo",
      title: "Dall'idea al feed, in quattro passi.",
      steps: [
        { t: "Ascolto", d: "Conosco te, il tuo pubblico e i tuoi obiettivi." },
        { t: "Strategia", d: "Definisco tono, formati e calendario editoriale." },
        { t: "Creazione", d: "Produco contenuti e design curati in ogni dettaglio." },
        { t: "Crescita", d: "Analizzo i dati e ottimizzo, mese dopo mese." },
      ],
    },
    pricing: {
      over: "Prezzi",
      title: "Chiari, senza sorprese.",
      plans: [
        { id: "web", t: "Creazione Sito Web", p: "€1.000", per: "una tantum", f: ["Design su misura, niente template", "Responsive e mobile-first", "SEO base e performance", "Form contatti e link social", "Testi orientati alla conversione"] },
        { id: "social", t: "Gestione Social Media", p: "€300", per: "/ mese", f: ["Piano editoriale mensile", "Grafiche, reel e storie", "Copywriting e hashtag strategici", "Community management", "Report mensile dei risultati"], featured: true },
      ],
      popular: "Il più scelto",
      choose: "Scegli questo",
    },
    contact: {
      over: "Contatti",
      title: ["Pronta a far", "parlare di te?"],
      sub: "Raccontami il tuo progetto. Ti rispondo entro 24 ore.",
      name: "Il tuo nome",
      email: "La tua email",
      service: "Di cosa hai bisogno?",
      opts: { social: "Social media", web: "Sito web", both: "Entrambi" },
      message: "Raccontami il tuo progetto",
      send: "Invia messaggio",
      sending: "Invio in corso…",
      ok: "Messaggio inviato! Ti risponderò presto.",
      err: "Qualcosa è andato storto. Riprova o scrivimi via email.",
      invalid: "Compila tutti i campi (messaggio di almeno 10 caratteri).",
    },
    footer: { rights: "Tutti i diritti riservati.", top: "Torna su", write: "Scrivimi" },
    share: { label: "Condividi", copy: "Copia link", copied: "Link copiato!", text: "Guarda il sito di Lene Mauro, Social Media Manager & Web Designer:" },
    blog: {
      over: "Il blog",
      title: ["Idee, strategie", "e ispirazioni."],
      teaserTitle: "Dal blog: consigli per far crescere il tuo brand.",
      sub: "Consigli pratici su social media, brand identity e siti web, per farti notare e attrarre nuovi clienti.",
      all: "Tutti gli articoli",
      back: "Torna al blog",
      related: "Continua a leggere",
      notFound: "Articolo non trovato.",
      ctaTitle: "Vuoi applicarlo al tuo brand?",
      ctaSub: "Raccontami il tuo progetto oppure richiedi un'anteprima gratuita di come potrebbe apparire.",
      ctaContact: "Scrivimi",
      ctaGift: "Mockup gratuito",
      seoTitle: "Blog | Lene Mauro – Social Media Manager",
      seoDesc: "Consigli su social media marketing, Instagram, brand identity e siti web da Lene Mauro, Social Media Manager e Web Designer.",
    },
    booking: {
      over: "Chiamata conoscitiva gratuita",
      title: "Prenota subito 30 minuti con me.",
      sub: "Scegli giorno e orario: parliamo del tuo brand, dei tuoi obiettivi e di come raggiungerli. Disponibile dal lunedì al venerdì, dalle 10:00 alle 17:00.",
      pickDay: "Scegli un giorno dal calendario.",
      noSlots: "Nessun orario libero in questo giorno. Prova un'altra data.",
      time: "Orario",
      how: "Come preferisci sentirci?",
      modes: { video: "Videochiamata", phone: "Telefono" },
      name: "Il tuo nome",
      email: "La tua email",
      phone: "Numero di telefono",
      note: "Di cosa vuoi parlare? (facoltativo)",
      send: "Conferma la chiamata",
      needSlot: "Scegli giorno e orario.",
      invalid: "Inserisci nome, email valida e (per il telefono) il numero.",
      err: "Qualcosa è andato storto. Riprova.",
      okTitle: "Chiamata confermata!",
      ok: "Ti ho inviato un'email di conferma. Ci sentiamo presto!",
    },
    cookies: {
      title: "Cookie",
      text: "Uso cookie di analisi (Google Analytics) per capire come viene usato il sito e migliorarlo. Vengono memorizzati solo se accetti. Puoi cambiare idea in qualsiasi momento dal link “Preferenze cookie” in fondo alla pagina.",
      accept: "Accetta",
      reject: "Rifiuta",
      prefs: "Preferenze cookie",
      policy: "Leggi la Privacy e Cookie Policy",
      privacy: "Privacy e Cookie Policy",
    },
    thanks: {
      badge: "Messaggio inviato con successo",
      title: ["Grazie! Ora iniziamo", "a costruire il tuo brand."],
      sub: "Ho ricevuto il tuo messaggio e ti risponderò al più presto. Nel frattempo, ecco perché una brand identity forte e un piano settimanale costante sono la chiave per attrarre nuovi clienti.",
      brandOver: "Brand identity",
      brandTitle: "Perché il tuo brand conta più del tuo prodotto.",
      brandIntro: "Le persone non scelgono solo cosa vendi: scelgono chi sei. Una brand identity chiara — colori, tono di voce, valori, stile visivo — ti rende riconoscibile in mezzo a mille profili e trasforma chi ti guarda in chi ti sceglie.",
      pillars: [
        { t: "Riconoscibilità", d: "Un'identità coerente fa sì che i tuoi contenuti vengano riconosciuti ancora prima di leggere il nome." },
        { t: "Fiducia", d: "Un'immagine curata comunica professionalità. E la fiducia è il primo passo verso un acquisto." },
        { t: "Differenziazione", d: "Raccontare i tuoi valori e il tuo stile ti distingue dalla concorrenza, senza dover competere sul prezzo." },
        { t: "Valore percepito", d: "Un brand forte giustifica prezzi più alti e crea clienti fedeli che ti consigliano ad altri." },
      ],
      weekOver: "Il progetto settimanale",
      weekTitle: "Sette giorni per attrarre nuovi clienti.",
      weekIntro: "La costanza batte la perfezione. Ecco il modello di settimana che uso per far crescere i brand che seguo: ogni giorno ha un obiettivo preciso.",
      days: [
        { day: "Lunedì", focus: "Strategia", d: "Analisi dei risultati della settimana precedente e pianificazione dei contenuti." },
        { day: "Martedì", focus: "Valore", d: "Un contenuto educativo: consigli e risposte alle domande dei tuoi clienti." },
        { day: "Mercoledì", focus: "Reel", d: "Un video breve e dinamico per raggiungere nuove persone e aumentare la visibilità." },
        { day: "Giovedì", focus: "Dietro le quinte", d: "Storie che mostrano chi sei e come lavori, per creare connessione e fiducia." },
        { day: "Venerdì", focus: "Prova sociale", d: "Recensioni, risultati e casi reali che convincono chi è ancora indeciso." },
        { day: "Sabato", focus: "Community", d: "Sondaggi, domande e risposte ai commenti per far crescere il coinvolgimento." },
        { day: "Domenica", focus: "Offerta", d: "Un invito chiaro all'azione: prenota, scrivi, acquista. Si chiude il cerchio." },
      ],
      resultTitle: "Cosa ottieni con questo metodo",
      results: ["Un profilo coerente e riconoscibile", "Più persone raggiunte ogni settimana", "Più fiducia verso il tuo brand", "Più richieste da potenziali clienti"],
      ctaTitle: "Il tuo brand merita di essere notato.",
      ctaSub: "Mentre preparo la risposta, seguimi su Instagram per altri consigli e ispirazioni.",
      ig: "Seguimi su Instagram",
      home: "Torna al sito",
    },
    faq: {
      over: "Domande frequenti",
      title: "Tutto quello che vuoi sapere.",
      items: [
        { q: "Quanto costa un social media manager?", a: "La gestione completa dei tuoi social costa €300 al mese: piano editoriale, grafiche, reel, storie, copy, community management e report mensile dei risultati." },
        { q: "Quanto costa creare un sito web professionale?", a: "Un sito web su misura costa €1.000 una tantum. Include design personalizzato, versione mobile, SEO di base, form contatti e collegamento ai social." },
        { q: "Su quali social lavori?", a: "Instagram, Facebook, TikTok e LinkedIn. Insieme scegliamo i canali giusti per il tuo pubblico e i tuoi obiettivi." },
        { q: "Posso avere sia la gestione social sia il sito web?", a: "Certo. Sito e social pensati insieme parlano la stessa lingua e rendono il tuo brand riconoscibile ovunque." },
        { q: "Cos'è il Mockup Visivo gratuito?", a: "È un'anteprima di come potrebbero apparire il tuo feed social o il tuo nuovo sito. Lasci la tua email e la ricevi gratis, senza impegno." },
      ],
    },
    gift: {
      over: "Regalo gratuito",
      title: ["Guarda il tuo brand", "prima di iniziare."],
      sub: "Lasciami la tua email e ricevi gratis un Mockup Visivo: un'anteprima di come potrebbero apparire il tuo feed social o il tuo nuovo sito.",
      points: ["Anteprima personalizzata sul tuo brand", "Foto e grafiche di esempio", "Nessun impegno, zero costi"],
      name: "Il tuo nome",
      email: "La tua email",
      business: "Attività o profilo Instagram (facoltativo)",
      kind: "Cosa vuoi vedere?",
      kinds: { social: "Feed social", web: "Sito web" },
      send: "Voglio il mio mockup gratis",
      sending: "Invio in corso…",
      okTitle: "Richiesta ricevuta!",
      ok: "Preparo il tuo mockup e te lo invio via email. A presto!",
      err: "Qualcosa è andato storto. Riprova.",
      invalid: "Inserisci nome ed email validi.",
      privacy: "Userò la tua email solo per inviarti il mockup e ricontattarti. Niente spam.",
      tag: "Gratis",
    },
  },
  en: {
    nav: { services: "Services", portfolio: "Work", blog: "Blog", gift: "Free gift", work: "Method", pricing: "Pricing", about: "About", contact: "Contact", cta: "Let's talk" },
    hero: {
      over: "Social Media Manager & Web Designer",
      lines: ["I make your", "brand impossible", "to ignore."],
      italic: 1,
      sub: "I manage your social media and build your website. Content that stops the scroll, sites that turn visits into clients.",
      cta1: "Start a project",
      cta2: "See pricing",
      badge: "Available for new projects",
      scroll: "Scroll",
      ring: "SOCIAL · WEBSITES · STRATEGY · CONTENT · ",
    },
    marquee: ["Social Media Management", "Bespoke Websites", "Digital Strategy", "Brand Identity", "Viral Content"],
    about: {
      over: "About",
      title: ["I don't just post content.", "I build attention."],
      p1: "I'm Lene Mauro. I help professionals and small businesses get noticed online, with a curated social presence and a website that works for them, day and night.",
      p2: "One single point of contact for strategy, content and web: fewer agencies to manage, more results to measure.",
      sign: "— Lene",
    },
    services: {
      over: "Services",
      title: "Two crafts, one vision.",
      items: [
        { n: "01", t: "Social Media Management", d: "Editorial plan, graphics, reels, stories and copy. Every month, consistently, with a recognisable voice.", tags: ["Instagram", "Facebook", "TikTok", "LinkedIn"] },
        { n: "02", t: "Website Creation", d: "Bespoke, fast, mobile-first websites. Built to tell your brand story and convert visitors.", tags: ["Design", "Development", "Basic SEO", "Contact form"] },
      ],
    },
    works: {
      over: "Selected work",
      title: "Before and after, no filters.",
      sub: "Social profiles and websites transformed. Click Before / After to see the difference.",
      before: "Before",
      after: "After",
      project: "Project",
      live: "Live",
      visit: "Visit the site",
      realDesc: { galliera: "Website for a dental clinic in San Venanzio di Galliera (Bologna): elegant design, visit booking front and centre and treatments presented clearly." },
      types: { social: "Social media", web: "Website", both: "Social + Website" },
    },
    bento: {
      over: "What you get",
      title: "Details that make the difference.",
      a: { t: "Visual storytelling", d: "A consistent aesthetic that makes your profile recognisable at first glance." },
      b: { t: "Built to convert", d: "Every page leads to one clear action.", cta: "Book now" },
      c: { t: "Mobile first", d: "Perfect on the screen where your clients spend their time." },
      d: { t: "Continuous growth", d: "Monthly reports to understand what works and improve every month." },
    },
    process: {
      over: "Method",
      title: "From idea to feed, in four steps.",
      steps: [
        { t: "Listen", d: "I get to know you, your audience and your goals." },
        { t: "Strategy", d: "I define tone, formats and the editorial calendar." },
        { t: "Create", d: "I produce content and design crafted in every detail." },
        { t: "Grow", d: "I analyse the data and optimise, month after month." },
      ],
    },
    pricing: {
      over: "Pricing",
      title: "Clear, no surprises.",
      plans: [
        { id: "web", t: "Website Creation", p: "€1,000", per: "one-time", f: ["Bespoke design, no templates", "Responsive & mobile-first", "Basic SEO & performance", "Contact form & social links", "Conversion-focused copy"] },
        { id: "social", t: "Social Media Management", p: "€300", per: "/ month", f: ["Monthly editorial plan", "Graphics, reels & stories", "Strategic copy & hashtags", "Community management", "Monthly results report"], featured: true },
      ],
      popular: "Most chosen",
      choose: "Choose this",
    },
    contact: {
      over: "Contact",
      title: ["Ready to get", "people talking?"],
      sub: "Tell me about your project. I'll reply within 24 hours.",
      name: "Your name",
      email: "Your email",
      service: "What do you need?",
      opts: { social: "Social media", web: "Website", both: "Both" },
      message: "Tell me about your project",
      send: "Send message",
      sending: "Sending…",
      ok: "Message sent! I'll get back to you soon.",
      err: "Something went wrong. Try again or email me.",
      invalid: "Please fill in all fields (message at least 10 characters).",
    },
    footer: { rights: "All rights reserved.", top: "Back to top", write: "Write to me" },
    share: { label: "Share", copy: "Copy link", copied: "Link copied!", text: "Check out Lene Mauro, Social Media Manager & Web Designer:" },
    blog: {
      over: "The blog",
      title: ["Ideas, strategies", "and inspiration."],
      teaserTitle: "From the blog: tips to grow your brand.",
      sub: "Practical tips on social media, brand identity and websites, to get noticed and attract new clients.",
      all: "All articles",
      back: "Back to the blog",
      related: "Keep reading",
      notFound: "Article not found.",
      ctaTitle: "Want to apply this to your brand?",
      ctaSub: "Tell me about your project or request a free preview of how it could look.",
      ctaContact: "Write to me",
      ctaGift: "Free mockup",
      seoTitle: "Blog | Lene Mauro – Social Media Manager",
      seoDesc: "Tips on social media marketing, Instagram, brand identity and websites by Lene Mauro, Social Media Manager & Web Designer.",
    },
    booking: {
      over: "Free discovery call",
      title: "Book 30 minutes with me now.",
      sub: "Pick a day and time: we'll talk about your brand, your goals and how to reach them. Available Monday to Friday, 10:00 to 17:00 (Italian time).",
      pickDay: "Pick a day from the calendar.",
      noSlots: "No free times on this day. Try another date.",
      time: "Time",
      how: "How would you like to talk?",
      modes: { video: "Video call", phone: "Phone" },
      name: "Your name",
      email: "Your email",
      phone: "Phone number",
      note: "What would you like to discuss? (optional)",
      send: "Confirm the call",
      needSlot: "Please pick a day and time.",
      invalid: "Enter your name, a valid email and (for phone) your number.",
      err: "Something went wrong. Please try again.",
      okTitle: "Call confirmed!",
      ok: "I've sent you a confirmation email. Talk soon!",
    },
    cookies: {
      title: "Cookies",
      text: "I use analytics cookies (Google Analytics) to understand how the site is used and improve it. They're only enabled if you accept. You can change your mind anytime via “Cookie preferences” at the bottom of the page.",
      accept: "Accept",
      reject: "Reject",
      prefs: "Cookie preferences",
      policy: "Read the Privacy & Cookie Policy",
      privacy: "Privacy & Cookie Policy",
    },
    thanks: {
      badge: "Message sent successfully",
      title: ["Thank you! Now let's", "build your brand."],
      sub: "I've received your message and will reply as soon as possible. Meanwhile, here's why a strong brand identity and a consistent weekly plan are the key to attracting new clients.",
      brandOver: "Brand identity",
      brandTitle: "Why your brand matters more than your product.",
      brandIntro: "People don't just choose what you sell: they choose who you are. A clear brand identity — colours, tone of voice, values, visual style — makes you recognisable among a thousand profiles and turns viewers into clients.",
      pillars: [
        { t: "Recognition", d: "A consistent identity makes your content recognisable before anyone reads your name." },
        { t: "Trust", d: "A curated image communicates professionalism. And trust is the first step towards a purchase." },
        { t: "Differentiation", d: "Telling your values and style sets you apart from competitors, without competing on price." },
        { t: "Perceived value", d: "A strong brand justifies higher prices and creates loyal clients who recommend you." },
      ],
      weekOver: "The weekly plan",
      weekTitle: "Seven days to attract new clients.",
      weekIntro: "Consistency beats perfection. Here's the weekly model I use to grow the brands I work with: every day has a precise goal.",
      days: [
        { day: "Monday", focus: "Strategy", d: "Review last week's results and plan the content." },
        { day: "Tuesday", focus: "Value", d: "An educational post: tips and answers to your clients' questions." },
        { day: "Wednesday", focus: "Reel", d: "A short, dynamic video to reach new people and boost visibility." },
        { day: "Thursday", focus: "Behind the scenes", d: "Stories showing who you are and how you work, to build connection and trust." },
        { day: "Friday", focus: "Social proof", d: "Reviews, results and real cases that convince those still undecided." },
        { day: "Saturday", focus: "Community", d: "Polls, Q&As and replies to comments to grow engagement." },
        { day: "Sunday", focus: "Offer", d: "A clear call to action: book, message, buy. The loop closes." },
      ],
      resultTitle: "What you get with this method",
      results: ["A consistent, recognisable profile", "More people reached every week", "More trust in your brand", "More enquiries from potential clients"],
      ctaTitle: "Your brand deserves to be noticed.",
      ctaSub: "While I prepare my reply, follow me on Instagram for more tips and inspiration.",
      ig: "Follow me on Instagram",
      home: "Back to the site",
    },
    faq: {
      over: "FAQ",
      title: "Everything you want to know.",
      items: [
        { q: "How much does a social media manager cost?", a: "Full management of your social media costs €300 per month: editorial plan, graphics, reels, stories, copy, community management and a monthly results report." },
        { q: "How much does a professional website cost?", a: "A bespoke website costs €1,000 one-time. It includes custom design, mobile version, basic SEO, contact form and social links." },
        { q: "Which social platforms do you work on?", a: "Instagram, Facebook, TikTok and LinkedIn. Together we choose the right channels for your audience and goals." },
        { q: "Can I get both social media and a website?", a: "Of course. A website and socials designed together speak the same language and make your brand recognisable everywhere." },
        { q: "What is the free Visual Mockup?", a: "It's a preview of how your social feed or new website could look. Leave your email and get it for free, no commitment." },
      ],
    },
    gift: {
      over: "Free gift",
      title: ["See your brand", "before we start."],
      sub: "Leave your email and get a free Visual Mockup: a preview of how your social feed or your new website could look.",
      points: ["Preview tailored to your brand", "Sample photos and graphics", "No commitment, zero cost"],
      name: "Your name",
      email: "Your email",
      business: "Business or Instagram handle (optional)",
      kind: "What do you want to see?",
      kinds: { social: "Social feed", web: "Website" },
      send: "Get my free mockup",
      sending: "Sending…",
      okTitle: "Request received!",
      ok: "I'll prepare your mockup and email it to you. Talk soon!",
      err: "Something went wrong. Please try again.",
      invalid: "Please enter a valid name and email.",
      privacy: "I'll only use your email to send the mockup and get back to you. No spam.",
      tag: "Free",
    },
  },
};

export const useT = () => dict[useLang().lang];
